function computeAutoDiscountLineSaveCents(discountType, quota, priceCents, quantity) {
  const price = Number(priceCents) || 0;
  const quotaNum = Number(quota) || 0;
  const qty = Number(quantity) || 0;
  if (price <= 0 || quotaNum <= 0 || qty <= 0) return 0;

  let unitCents =
    discountType === 'amount' ? Math.round(quotaNum * 100) : Math.floor((price * quotaNum) / 100);
  if (unitCents > price) unitCents = price;
  return unitCents * qty;
}

function formatTotalAutoDiscountBadge(offLabel, lines, moneyFormat) {
  if (!Array.isArray(lines) || !window.Shopify?.formatMoney) return '';

  let totalCents = 0;
  for (const line of lines) {
    totalCents += computeAutoDiscountLineSaveCents(
      line.type,
      line.quota,
      line.priceCents,
      line.quantity
    );
  }
  if (totalCents <= 0) return '';

  const save = offLabel || 'Save';
  return `${save} ${window.Shopify.formatMoney(totalCents, moneyFormat)}`;
}

$(function () {
  // 客户端状态初始化
  // 初始化命名空间
  window.litime = {
    version: window.litimePreConfig?.version ?? 'v1',
    debounce,
    throttle,
    showLoading,
    hideLoading,
    openChatApp,
    disableScroll,
    enableScroll,
    i18n: {}, // 添加 i18n 对象
    initWhenVisible,
    addCart,
    openProductModalV2,
    tryOpenProductModalV2,
    isProductModalV2Enabled,
    // 导出便捷方法
    http: {
      get: (url, options = {}, prefix) => request(url, { ...options, method: 'GET' }, prefix),
      post: (url, options = {}, prefix) => request(url, { ...options, method: 'POST' }, prefix),
      put: (url, options = {}, prefix) => request(url, { ...options, method: 'PUT' }, prefix),
      delete: (url, options = {}, prefix) => request(url, { ...options, method: 'DELETE' }, prefix),
      patch: (url, options = {}, prefix) => request(url, { ...options, method: 'PATCH' }, prefix),
    },
    // 默认导出request函数
    request,
    rsaEncryptWithCrypto,
    eventBus: new EventBus(),
    initWhenVisible,
    copyToClipboard,
    setLocalStorage,
    getLocalStorage,
    getCookie,
    clearLocalStorage,
    onVisibleOnce,
    openLitimeApp,
    fireworks,
    shopifyLogout,
    isRectIntersectingViewport,
    computeAutoDiscountLineSaveCents,
    formatTotalAutoDiscountBadge,
  };
});

/**
 * 视图滚动动画
 * 使用方法：
 * 1. 多元素
 * <div lt-scrollspy="target: .scroll-inview-item; y: 30;">
 *   <div class="scroll-inview-item">Item 1</div>
 *   <div class="scroll-inview-item">Item 2</div>
 *   <div class="scroll-inview-item">Item 3</div>
 * </div>
 *  参数：
 * target: 目标元素
 * x: 水平偏移，默认为0
 * y: 垂直偏移，默认为0
 * duration: 动画持续时间，默认为0.6
 * delay: 每个元素的延迟时间，默认为0.15
 * ease: 缓动函数，默认为''
 *
 * 2. 单独元素
 * <div lt-scroll-inview="y: 30;">
 *   <div>Item 1</div>
 *   <div>Item 2</div>
 *   <div>Item 3</div>
 *   <div>Item 4</div>
 * </div>
 * 参数：
 * x: 水平偏移，默认为0
 * y: 垂直偏移，默认为0
 * duration: 动画持续时间，默认为0.6
 * delay: 每个元素的延迟时间，默认为0.15
 * ease: 缓动函数，默认为''
 */
class ScrollAnimations {
  constructor() {
    this.init();
  }

  init() {
    // 处理多元素动画
    document.querySelectorAll('[lt-scrollspy]').forEach((container) => {
      const config = this.parseConfig(container.getAttribute('lt-scrollspy'));
      const targets = container.querySelectorAll(config.target);

      const originOverflow = container.style.overflow;
      container.style.overflow = 'initial';

      // 初始化隐藏所有目标元素
      $(targets).each((index, element) => {
        // 保存原始过渡效果
        const originalTransition = $(element).css('transition');
        const animationTransition = `opacity ${config.duration}s, transform ${config.duration}s ${config.ease}`;

        // 合并过渡效果，确保不覆盖原有效果
        const combinedTransition =
          originalTransition && originalTransition !== 'none'
            ? `${originalTransition}, ${animationTransition}`
            : animationTransition;

        $(element).css({
          opacity: 0,
          transform: `translate(${config.x}px, ${config.y}px)`,
          transition: combinedTransition,
        });
      });

      // 创建观察器监控容器
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // 当容器可见时，依次显示所有元素
              $(targets).each((index, element) => {
                setTimeout(
                  () => {
                    $(element).css({
                      opacity: config.opacity,
                      transform: 'translate(0, 0)',
                    });

                    // 最后一个元素动画完成后恢复原始overflow
                    if (index === targets.length - 1) {
                      setTimeout(() => {
                        container.style.overflow = originOverflow;
                      }, config.duration * 1000);
                    }
                  },
                  index * config.delay * 1000,
                );
              });

              // 一旦触发，取消观察
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0,
          rootMargin: '0px 0px -20% 0px',
        },
      );

      observer.observe(container);
    });

    // 处理单独元素动画
    document.querySelectorAll('[lt-scroll-inview]').forEach((element) => {
      const config = this.parseConfig(element.getAttribute('lt-scroll-inview'));

      // 如果当前宽度小于 minWidth，则直接返回，不使用动画
      if (config.minWidth && window.innerWidth <= config.minWidth) {
        return;
      }

      // 保存原始过渡效果
      const originalTransition = $(element).css('transition');
      const animationTransition = `opacity ${config.duration}s, transform ${config.duration}s ${config.ease}`;

      const combinedTransition =
        originalTransition && originalTransition !== 'none'
          ? `${originalTransition}, ${animationTransition}`
          : animationTransition;

      // 初始化隐藏
      $(element).css({
        opacity: 0,
        transform: `translate(${config.x}px, ${config.y}px)`,
        transition: combinedTransition,
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              $(element).css({
                opacity: config.opacity,
                transform: 'translate(0, 0)',
              });
              observer.unobserve(entry.target);

              // 动画帧结束后移除内联样式，避免 transform 等影响弹窗等后续显示
              const durationMs = (config.duration || 0.6) * 1000;
              setTimeout(() => {
                $(element).css({ opacity: '', transform: '', transition: '' });
              }, durationMs);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -10% 0px',
        },
      );

      observer.observe(element);
    });
  }

  // 解析配置
  parseConfig(attr) {
    // 默认配置
    const config = {
      target: '.scroll-inview-item',
      opacity: 1, // 目标透明度
      x: 0, // 初始 X 偏移
      y: 0, // 初始 Y 偏移
      duration: 0.6, // 动画持续时间
      delay: 0.15, // 每个元素的延迟时间
      ease: '', // 缓动函数
      minWidth: 0, // 🆕 默认不限制
    };

    if (!attr) return config;

    // 解析属性字符串
    attr.split(';').forEach((item) => {
      const [key, value] = item.split(':').map((str) => str.trim());
      if (key && value) {
        // 🆕 数值类型字段列表扩展 minWidth
        if (['x', 'y', 'duration', 'delay', 'minWidth'].includes(key)) {
          config[key] = parseFloat(value);
        } else {
          config[key] = value;
        }
      }
    });

    return config;
  }
}
// 初始化视图滚动动画
$(document).ready(() => {
  new ScrollAnimations();
});
// scroll-animation[End]

function initWhenVisible(options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    },
    { rootMargin: `0px 0px ${threshold}px 0px` },
  );

  observer.observe(options.element);
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

(function () {
  const escapeSelector = (selector) => {
    return selector.replace(/([.#:[\]\\])/g, '\\$1');
  };

  $(document.body).on('click', 'a[href^="#"]', function (event) {
    event.preventDefault();
    const $link = $(this);
    let originalHref = $link.attr('href') || '';

    // 统一处理空href
    if (!originalHref || originalHref === '#') {
      $link.attr('href', 'javascript:;');
      return;
    }

    // 提取并验证hash
    const hashMatch = originalHref.match(/#(.+)/);
    if (!hashMatch) {
      $link.attr('href', 'javascript:;');
      return;
    }

    const targetId = escapeSelector(hashMatch[1]);
    const $target = $(`#${targetId}`);

    // 目标不存在处理
    if (!$target.length) {
      console.warn(`Anchor target #${targetId} not found`);
      $link.attr('href', 'javascript:;');
      return;
    }

    // 滚动逻辑（保持原有优化）
    const targetElement = document.getElementById(hashMatch[1]);
    const headerHeight = document.querySelector('header')?.offsetHeight || 0;
    // 读取 data-offset，默认值为 0
    const offset = parseInt(event.currentTarget?.dataset.offset || '0', 10);
    const scrollPosition = targetElement.offsetTop - headerHeight - offset;

    try {
      if ('scrollBehavior' in document.documentElement.style) {
        window.scrollTo({
          top: scrollPosition,
          behavior: 'smooth',
        });
      } else {
        $('html, body').stop().animate({ scrollTop: scrollPosition }, { duration: 200, easing: 'swing' });
      }
    } catch (error) {
      console.error('Scroll error:', error);
    }

    // 焦点管理
    if (document.activeElement !== targetElement) {
      targetElement.setAttribute('tabindex', '-1');
      targetElement.focus({ preventScroll: true });
    }
  });
})();

/**
 * 为元素添加唯一事件监听器
 * @param {HTMLElement} element - 需要绑定事件的元素
 * @param {string} eventType - 事件类型，如 'click'
 * @param {Function} handler - 事件处理函数
 * 使用方式
 * customEventListener(button, 'click', () => {
      
    });
 */
function customEventListener(element, eventType, handler) {
  if (element && !element._eventListeners) {
    //
    element._eventListeners = {};
  }

  if (element && !element._eventListeners[eventType]) {
    element.addEventListener(eventType, handler);
    element._eventListeners[eventType] = handler; // 记录已绑定事件
  }
}

/**
 * 格式化价格
 * @param {number} cents - 需要格式化的价格
 * @param {string} format - 格式化字符串
 * @returns {string} 格式化后的价格
 * 使用方式
 * Shopify.formatMoney(100, '{{ shop.money_format }}');
 */
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/** 判断矩形是否与当前可视区域相交（含 mobile visualViewport） */
function isRectIntersectingViewport(rect) {
  if (!rect || rect.width <= 0 || rect.height <= 0) return false;

  const vv = window.visualViewport;
  const top = vv ? vv.offsetTop : 0;
  const left = vv ? vv.offsetLeft : 0;
  const vh = vv ? vv.height : window.innerHeight;
  const vw = vv ? vv.width : window.innerWidth;

  return rect.bottom > top && rect.top < top + vh && rect.right > left && rect.left < left + vw;
}

// 防抖函数
function debounce(fn, delay = 300) {
  let timer = null;

  return function (...args) {
    if (timer) clearTimeout(timer);

    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

// 节流函数
function throttle(fn, delay = 300) {
  let timer = null;

  return function (...args) {
    if (timer) return;

    timer = setTimeout(() => {
      fn.apply(this, args);
      timer = null;
    }, delay);
  };
}

function showLoading(isDisableScroll = true) {
  $('.global-loading_wrapper').addClass('flex').removeClass('hidden');
  if (isDisableScroll) {
    window.litime.disableScroll();
  }
}

function hideLoading(isEnableScroll = true) {
  $('.global-loading_wrapper').removeClass('flex').addClass('hidden');
  if (isEnableScroll) {
    window.litime.enableScroll();
  }
}

function getMiniCartSectionId() {
  const el = document.querySelector('global-mini-cart-v2, cart-drawer');
  return el?.dataset?.sectionId || el?.getAttribute('data-section-id') || '';
}

async function getCartDrawer(triggerElement = null) {
  const sectionId = getMiniCartSectionId();
  if (!sectionId) return;
  const cartDrawer = document.querySelector('#' + sectionId);
  if (cartDrawer) {
    // document.querySelector('.empty-cart-drawer').classList.remove('hidden');
    // document.querySelector('.cart-drawer-content').classList.add('hidden');
    // document.querySelector('.bottom-drawer-container').classList.add('hidden');
    // 打开购物车抽屉，如果有触发元素就传入
    cartDrawer.open(triggerElement);
    // 更新购物车内容
    await cartDrawer.getCartContent();
  }
}

// 添加全局遮罩层管理
window.overlayManager = {
  $overlay: null,
  currentType: null, // 添加当前遮罩层类型标记

  show(type = 'drawer') {
    // 先移除所有可能存在的遮罩层
    $('.overlay-mask, .drawer-overlay-mask').remove();

    // 设置当前类型
    this.currentType = type;
    const scrollbarWidth = getScrollbarWidth();

    window.litime.disableScroll();

    // 根据类型创建不同的遮罩层
    if (type === 'header') {
      this.$overlay = $('<div></div>')
        .addClass('overlay-mask')
        .css({
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 99,
          marginLeft: `-${scrollbarWidth}px`,
        });
    } else if (type === 'header-search' || type === 'header-search-v2') {
      this.$overlay = $('<div></div>')
        .addClass('search-overlay-mask')
        .css({
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 99,
          marginLeft: `-${scrollbarWidth}px`,
        });
    } else {
      this.$overlay = $('<div></div>').addClass('drawer-overlay-mask').css({
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 800,
      });
    }

    $('#MainContent').append(this.$overlay);
    return this.$overlay;
  },

  hide(type = 'drawer') {
    // 只有当要隐藏的类型与当前显示的类型相同时才执行隐藏
    if (type === this.currentType) {
      if (this.$overlay) {
        this.$overlay.remove();
        this.$overlay = null;
      }
      // 只移除对应类型的遮罩层
      if (type === 'header') {
        $('.overlay-mask').remove();
      } else if (type === 'header-search' || type === 'header-search-v2') {
        $('.search-overlay-mask').remove();
      } else {
        $('.drawer-overlay-mask').remove();
      }
      window.litime.enableScroll();

      this.currentType = null;
    }
  },

  get() {
    return this.$overlay;
  },
};

function openChatApp() {
  // const shopName = window.base_info.shopName;
  const chatwootTriggerEle = document.querySelector('.woot-widget-bubble');
  const nextopChatTriggerEle = document.querySelector('#nextop-chat');
  const lucasTriggerEle = document.querySelector('[data-lucas-chat-floating] .lucas-chat-launcher');
  if (lucasTriggerEle) {
    lucasTriggerEle.click();
  } else if (chatwootTriggerEle) {
    chatwootTriggerEle.click();
  } else if (nextopChatTriggerEle) {
    NextopLiveChat('openChat');
  } else {
    const chatApp = document.querySelector('#ShopifyChat');
    if (chatApp) {
      const shadowRoot = chatApp.shadowRoot;
      const button = shadowRoot.querySelector('button');
      button.click();
    }
  }
}

// 添加获取滚动条宽度的函数
function getScrollbarWidth() {
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll';
  document.body.appendChild(outer);

  const inner = document.createElement('div');
  outer.appendChild(inner);

  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
  outer.parentNode.removeChild(outer);

  return scrollbarWidth;
}
function preventDefault(e) {
  e.preventDefault();
}
// 添加禁用滚动条的方法
function disableScroll(type = 'body') {
  let scrollbarWidth = getScrollbarWidth();
  document.body.style.overflow = 'hidden';
  if (type === 'header') {
    scrollbarWidth = 0;
  }
  document.body.style.paddingRight = `${scrollbarWidth}px`;
  // 2. 添加 touchmove 阻止
  // document.addEventListener('touchmove', preventDefault, { passive: false });
  // 处理固定定位的元素
  document.querySelectorAll('.fixed-header, .fixed-element').forEach((el) => {
    el.style.paddingRight = `${scrollbarWidth}px`;
  });
}
// 添加恢复滚动条的方法
function enableScroll() {
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';
  document.removeEventListener('touchmove', preventDefault);

  // 处理固定定位的元素
  document.querySelectorAll('.fixed-header, .fixed-element').forEach((el) => {
    el.style.paddingRight = '';
  });
}
// 正则校验

const ltUtils = {
  rule: {
    email: /^[^@\s]+@[^.@\s]+\.[^@\s]+$/, //邮箱规则：任何值
    password_confirmation: /^.{6,}$/,
    password: /^.{6,}$/,
    any_value: /^.+$/, //规则: 任何值
  },
};
const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// 解析和更新购物车相关组件
async function updateCartComponents(cartContent) {
  if (!cartContent?.sections) return;

  const parser = new DOMParser();

  // 更新购物车抽屉-v2
  const miniCartSectionId = getMiniCartSectionId();
  if (miniCartSectionId && cartContent.sections[miniCartSectionId]) {
    const doc = parser.parseFromString(cartContent.sections[miniCartSectionId], 'text/html');
    const globalMiniCartV2 = document.querySelector('#' + miniCartSectionId);
    const globalMiniCartV2Content = doc.querySelector('#' + miniCartSectionId);
    if (globalMiniCartV2 && globalMiniCartV2Content) {
      const wasOpen = globalMiniCartV2.hasAttribute('open');
      globalMiniCartV2.innerHTML = globalMiniCartV2Content.innerHTML;
      globalMiniCartV2.bindRemoveButtons(); // 先重新绑定删除按钮事件
      globalMiniCartV2.init(); // 然后初始化其他功能
      // 购物车打开时内容刷新后，确保遮罩层仍存在
      if (wasOpen && typeof globalMiniCartV2.overlayMask === 'function') {
        globalMiniCartV2.overlayMask(true);
      }
    }
  }
  // 更新购物车图标
  if (cartContent.sections['cart-icon-bubble']) {
    const iconDoc = parser.parseFromString(cartContent.sections['cart-icon-bubble'], 'text/html');
    const iconBubble = document.querySelector('cart-icon-bubble');
    if (iconBubble) {
      iconBubble.innerHTML = iconDoc.querySelector('cart-icon-bubble').innerHTML;
    }
  }
}

/**
 * 使用Web Crypto API进行RSA加密
 * @param {string} publicKey PEM格式的公钥
 * @param {string} data 要加密的数据
 * @returns {Promise<string>} Base64编码的加密结果
 */
function rsaEncryptWithCrypto(publicKey, data) {
  try {
    // 创建JSEncrypt实例
    const encryptor = new JSEncrypt();
    const baseKey = atob(publicKey);
    let pubKey = `-----BEGIN PUBLIC KEY-----\n${baseKey}\n-----END PUBLIC KEY-----`;
    // 设置公钥
    encryptor.setPublicKey(pubKey);
    // 加密数据
    const encrypted = encryptor.encrypt(data);
    return encrypted;
  } catch (error) {
    throw error;
  }
}

// 创建事件总线
class EventBus {
  constructor() {
    this.events = new Map();
  }

  // 订阅事件
  subscribe(event, callback) {
    if (!this.events.has(event)) {
      this.events.set(event, new Set());
    }
    this.events.get(event).add(callback);

    // 返回取消订阅的函数
    return () => {
      const callbacks = this.events.get(event);
      callbacks.delete(callback);
      if (callbacks.size === 0) {
        this.events.delete(event);
      }
    };
  }

  // 发布事件
  publish(event, data) {
    if (this.events.has(event)) {
      this.events.get(event).forEach((callback) => {
        callback(data);
      });
    }
  }
}

// 复制文本到剪贴板
function copyToClipboard(text) {
  // 创建一个临时的textarea元素
  const textarea = document.createElement('textarea');
  textarea.value = text;
  document.body.appendChild(textarea);

  // 选择文本
  textarea.select();
  textarea.setSelectionRange(0, 99999);

  document.execCommand('copy');

  // 移除临时元素
  document.body.removeChild(textarea);

  window.litime.showToast('success', window.i18n.copy_susscess);
}

// 在全局点击事件监听中添加
document.addEventListener('click', async (e) => {
  const buyNowBtn = e.target.closest('.buy-now-btn-card-button');
  if (!buyNowBtn) return;
  const variantId = buyNowBtn.dataset.first_variant_id;
  if (!variantId) return;
  $(buyNowBtn).find('.rotate_icon').removeClass('hidden').addClass('flex');
  $(buyNowBtn).find('.loading-button-text').addClass('hidden').removeClass('flex');
  window.location.href = `/cart/${variantId}:1`;
});
window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    window.location.reload();
  }
});
function addCart(items = []) {
  const miniCartSectionId = getMiniCartSectionId();
  if (!miniCartSectionId) {
    return Promise.reject(new Error('Mini cart not found'));
  }
  return new Promise((resolve, reject) => {
    const miniCart = document.querySelector('#' + miniCartSectionId);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: items,
        sections: miniCart ? miniCart.getSectionsToRender().map((section) => section.id) : [],
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status && data.status != 200) {
          window.litime.showToast('error', data.description);
          reject(data);
        } else {
          if (window.location.pathname === '/cart') {
            window.location.reload();
            window.scrollTo(0, 0);
          } else {
            miniCart.renderContents(data);
          }
          resolve(data);
        }
      })
      .catch((error) => {
        console.error('添加到购物车失败:', error);
        reject(error);
      });
  });
}

let mainProductModalV2LoadingPromise = null;

function loadMainProductModalV2Script() {
  if (customElements.get('main-product-modal-v2')) {
    return Promise.resolve();
  }

  if (mainProductModalV2LoadingPromise) {
    return mainProductModalV2LoadingPromise;
  }

  const scriptUrl = window.cdnUrl?.mainProductModalV2;
  if (!scriptUrl) {
    return Promise.reject(new Error('[loadMainProductModalV2Script] window.cdnUrl.mainProductModalV2 is not defined'));
  }

  mainProductModalV2LoadingPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    script.onload = () => {
      if (customElements.get('main-product-modal-v2')) {
        resolve();
        return;
      }

      const waitForDefine = (attempt = 0) => {
        if (customElements.get('main-product-modal-v2')) {
          resolve();
          return;
        }
        if (attempt >= 20) {
          mainProductModalV2LoadingPromise = null;
          reject(new Error('[loadMainProductModalV2Script] main-product-modal-v2 custom element not registered'));
          return;
        }
        requestAnimationFrame(() => waitForDefine(attempt + 1));
      };
      waitForDefine();
    };
    script.onerror = () => {
      mainProductModalV2LoadingPromise = null;
      reject(new Error('[loadMainProductModalV2Script] Failed to load main-product-modal-v2.js'));
    };
    document.head.appendChild(script);
  });

  return mainProductModalV2LoadingPromise;
}

/**
 * 打开 Quick View V2 弹窗
 * @param {string} productHandle - 商品 handle（必填）
 * @param {number|string} [variantId] - 变体 id（可选）
 * @returns {Promise<HTMLElement|null>} 弹窗根节点 main-product-modal-v2
 */
function openProductModalV2(productHandle, variantId) {
  if (!productHandle) {
    return Promise.reject(new Error('[openProductModalV2] productHandle is required'));
  }

  let url = `/products/${encodeURIComponent(productHandle)}?view=modal-v2`;
  if (variantId != null && variantId !== '') {
    url += `&variant=${encodeURIComponent(variantId)}`;
  }

  return Promise.all([
    loadMainProductModalV2Script(),
    fetch(url).then((response) => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.text();
    }),
  ]).then(([, responseText]) => {
    const doc = new DOMParser().parseFromString(responseText, 'text/html');

    doc.querySelectorAll('script').forEach((script) => {
      script.textContent = '';
    });

    const quickshopRoot = doc.getElementById('quickshop-popup');
    quickshopRoot?.querySelector('main-product-modal-v2')?.setAttribute('data-show', 'false');
    const quickshopPopup = quickshopRoot?.innerHTML || '';
    const popupHost = document.getElementById('global-product-card-popup');

    if (!popupHost) {
      throw new Error('[openProductModalV2] #global-product-card-popup not found');
    }

    popupHost.innerHTML = quickshopPopup;

    const modalEl = popupHost.querySelector('main-product-modal-v2');
    if (modalEl?.open) {
      modalEl.open();
    } else {
      popupHost.setAttribute('aria-hidden', 'false');
      modalEl?.setAttribute('data-show', 'true');
      window.litime?.disableScroll?.();
    }

    return modalEl;
  });
}

function isProductModalV2Enabled() {
  return window.litime?.version === 'v2' && typeof openProductModalV2 === 'function';
}

/**
 * 按 version 尝试打开 V2 弹窗；未启用时返回 false，走原有逻辑
 * @param {string} productHandle
 * @param {number|string} [variantId]
 * @param {{ onBefore?: Function, onFinally?: Function }} [options]
 * @returns {boolean}
 */
function tryOpenProductModalV2(productHandle, variantId, options = {}) {
  if (!isProductModalV2Enabled() || !productHandle) {
    return false;
  }

  const { onBefore, onFinally } = options;
  onBefore?.();

  openProductModalV2(productHandle, variantId)
    .catch((error) => {
      console.error('[tryOpenProductModalV2] open modal v2 error:', error);
      window.litime?.enableScroll?.();
    })
    .finally(() => {
      onFinally?.();
    });

  return true;
}

/**
 * 功能：实现单个产品的添加到购物车
 * 要求：
 * 1. 必须提供 `variant-id`（产品变体 ID）。
 * 2. `quantity` 固定为 1（不可修改）。
 */

class AddToCart extends HTMLElement {
  constructor() {
    super();
    this.cart_add_url = '/cart/add.js';
    const miniCartSectionId = getMiniCartSectionId();
    this.miniCart = document.querySelector('#' + miniCartSectionId);

    // 创建防抖版本的点击处理器，防止连续点击
    this.debouncedClickHandler = debounce(this.onClickHandler, 300);
  }

  connectedCallback() {
    this.addEventListener('click', this.debouncedClickHandler);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.debouncedClickHandler);
  }

  onClickHandler = () => {
    const variantId = this.dataset.variantId;
    const variantSize = this.dataset.variantSize;
    if (variantSize > 1) {
      return false;
    }

    if (variantId) {
      if (document.body.classList.contains('cart-drawer')) {
        Shopify.postLink(this.cart_add_url, {
          parameters: {
            id: variantId,
            quantity: 1,
          },
        });
        return;
      }

      this.showLoading();

      const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];
      const body = JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
        sections: sections,
        sections_url: window.location.pathname,
      });

      fetch(`${this.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status === 422) {
            window.litime.showToast('error', parsedState.description);
            document.dispatchEvent(
              new CustomEvent('ajaxProduct:error', {
                detail: {
                  errorMessage: parsedState.description,
                },
              }),
            );
          } else {
            this.miniCart && this.miniCart.renderContents(parsedState);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.hideLoading();
        });
    }
  };

  // toggle loading visuals inside button
  showLoading() {
    try {
      const loadingText = this.querySelector('.loading-button-text');
      const loadingIcon = this.querySelector('i, .rotate_icon');
      if (loadingText) {
        loadingText.classList.add('hidden');
        loadingText.classList.remove('flex');
      }
      if (loadingIcon) {
        loadingIcon.classList.remove('hidden');
        loadingIcon.classList.add('flex');
      }
    } catch (err) {
      console.error('AddToCart.showLoading error', err);
    }
  }

  hideLoading() {
    try {
      const loadingText = this.querySelector('.loading-button-text');
      const loadingIcon = this.querySelector('i, .rotate_icon');
      if (loadingIcon) {
        loadingIcon.classList.add('hidden');
        loadingIcon.classList.remove('flex');
      }
      if (loadingText) {
        loadingText.classList.remove('hidden');
        loadingText.classList.add('flex');
      }
    } catch (err) {
      console.error('AddToCart.hideLoading error', err);
    }
  }
}

/**
 * 动态添加到购物车组件
 * 支持动态变体ID和数量  id  quantity
 * 支持多变体产品  data-variant-size >1
 * 支持单变体产品  data-variant-size = 1
 * 支持产品详情弹窗  data-model-show = true
 * 支持产品详情弹窗关闭  data-model-show = false
 * 支持产品详情弹窗打开  data-model-show = true
 *
 *
 *
 * info: 可以添加properties属性, 默认为{} , 可以添加关联产品window.selectedProducts
 */
class DynamicAddToCart extends HTMLElement {
  constructor() {
    super();
    this.cart_add_url = '/cart/add.js';
    this.miniCart = document.querySelector('cart-drawer')
      ? document.querySelector('cart-drawer')
      : document.querySelector('global-mini-cart-v2');

    // 创建防抖版本的点击处理器，防止连续点击
    this.debouncedClickHandler = debounce(this.onClickHandler, 300);
  }

  connectedCallback() {
    this.addEventListener('click', this.debouncedClickHandler);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.debouncedClickHandler);
  }

  /**
   * 获取变体ID
   * @returns {string|null} 变体ID
   */
  getVariantId() {
    // 检查是否允许变体变更
    const changeVariant = this.getAttribute('data-change-variant') === 'true';
    if (changeVariant) {
      // 多变体产品，从 .product-variant_active div 获取变体ID

      const modal = this.closest('product-detail-data-popup');
      if (modal) {
        const modalActiveVariant = modal.querySelector('.product-variant_active');
        if (modalActiveVariant) {
          const variantId = modalActiveVariant.getAttribute('data-product-variant-id');
          if (variantId) {
            return variantId;
          }
        }
      }
    }

    // 单变体产品或未找到选中变体时，使用默认逻辑
    let variantId = this.dataset.variantId;
    if (!variantId) {
      // 从 data-variant-id-selector 指定的元素获取
      const selector = this.dataset.variantIdSelector;
      if (selector) {
        const element = document.querySelector(selector);
        variantId = element?.value || element?.dataset.variantId;
      }
    }
    return variantId;
  }

  /**
   * 获取数量
   * @returns {number} 数量
   */
  getQuantity() {
    const selector = this.getAttribute('data-quantity-selector');
    console.log('selector', selector);

    if (selector) {
      let finalSelector = selector;

      // 如果选择器不包含 CSS 特殊字符，视为 name 属性
      if (!/[#.\[\]:>~+]/.test(selector)) {
        finalSelector = `[name='${selector}']`;
        console.log('treating as name attribute, final selector:', finalSelector);
      }

      const el = document.querySelector(finalSelector);
      console.log('el', el);
      if (el) {
        const raw = 'value' in el ? el.value : el.textContent;
        const n = parseInt(String(raw).trim(), 10);
        console.log('found quantity:', n, 'from element:', el);
        if (!Number.isNaN(n) && n > 0) return n;
      }
    }

    // 默认返回1
    console.log('no quantity found, defaulting to 1');
    return 1;
  }

  /**
   * 点击处理函数
   */
  onClickHandler = (event) => {
    // 阻止表单提交和默认行为
    event.preventDefault();
    event.stopPropagation();

    // 检查产品变体数量逻辑
    const productHandle = this.dataset.productHandle;
    const variantsSize = parseInt(this.getAttribute('data-variant-size')) || 1;
    const modelShow = this.getAttribute('data-model-show') === 'true';
    if (variantsSize > 1 && modelShow) {
      // 变体数量大于1且开启弹窗，唤起产品详情弹窗
      this.openProductDetailModal(productHandle);
      return;
    }

    // 变体数量<=1，直接添加到购物车
    const variantId = this.getVariantId();
    const quantity = this.getQuantity();

    if (!variantId) {
      console.error('DynamicAddToCart: 未找到变体ID');
      return;
    }

    // 检查是否需要跳转到购物车页面
    if (document.body.classList.contains('cart-drawer')) {
      Shopify.postLink(this.cart_add_url, {
        parameters: {
          id: variantId,
          quantity: quantity,
        },
      });
      return;
    }

    this.addToCart(variantId, quantity);
  };

  /**
   * 打开产品详情弹窗
   * @param {string} productHandle - 产品handle
   */
  openProductDetailModal(productHandle) {
    if (!productHandle) {
      console.error('DynamicAddToCart: 缺少产品handle');
      return;
    }

    try {
      const productListElement = this.closest('home-product-list, global-product, mini-product-intro-v2');
      if (productListElement && typeof productListElement.openProductDetailModal === 'function') {
        const inventoryPolicy = this.dataset.inventoryPolicy || 'deny';
        const view = this.dataset.view || 'default';
        productListElement.openProductDetailModal(this, inventoryPolicy, view);
        return;
      }
    } catch (error) {
      console.error('DynamicAddToCart: 打开产品详情弹窗失败:', error);
      window.location.href = `/products/${productHandle}`;
    }
  }

  /**
   * 关闭产品详情弹窗
   */
  closeProductDetailModal() {
    try {
      // 查找产品详情弹窗元素并关闭
      const productDetailModal = document.querySelector('product-detail-data-popup');
      if (productDetailModal) {
        productDetailModal.classList.add('hidden');
        productDetailModal.classList.remove('flex');

        // 恢复页面滚动
        if (window.litime && window.litime.enableScroll) {
          window.litime.enableScroll();
        }
        return;
      }

      document.dispatchEvent(
        new CustomEvent('dynamic-add-to-cart:closeModal', {
          detail: { source: 'dynamic-add-to-cart' },
        }),
      );
    } catch (error) {
      console.error('DynamicAddToCart: 关闭弹窗失败:', error);
    }
  }

  /**
   * 显示加载状态
   */
  showLoading() {
    try {
      // 隐藏文本，显示加载图标
      const loadingText = this.querySelector('.loading-button-text');
      const loadingIcon = this.querySelector('i, .rotate_icon');

      if (loadingText) {
        loadingText.classList.add('hidden');
        loadingText.classList.remove('flex');
      }

      if (loadingIcon) {
        loadingIcon.classList.remove('hidden');
        loadingIcon.classList.add('flex');
      }
    } catch (error) {
      console.error('DynamicAddToCart: 显示加载状态失败:', error);
    }
  }

  /**
   * 隐藏加载状态
   */
  hideLoading() {
    try {
      // 显示文本，隐藏加载图标
      const loadingText = this.querySelector('.loading-button-text');
      const loadingIcon = this.querySelector('i, .rotate_icon');

      if (loadingIcon) {
        loadingIcon.classList.add('hidden');
        loadingIcon.classList.remove('flex');
      }

      if (loadingText) {
        loadingText.classList.remove('hidden');
        loadingText.classList.add('flex');
      }
    } catch (error) {
      console.error('DynamicAddToCart: 隐藏加载状态失败:', error);
    }
  }

  /**
   * 添加到购物车
   * @param {string} variantId - 变体ID
   * @param {number} quantity - 数量
   */
  async addToCart(variantId, quantity) {
    // 显示加载状态
    this.showLoading();

    const sections =
      this.miniCart && typeof this.miniCart.getSectionsToRender === 'function'
        ? this.miniCart.getSectionsToRender().map((section) => section.id)
        : [getMiniCartSectionId(), 'cart-drawer', 'cart-icon-bubble'];

    // 主商品数量：无效或未传则回退 1
    const mainQty = (() => {
      const n = parseInt(quantity, 10);
      return Number.isFinite(n) && n > 0 ? n : 1;
    })();

    // 解析行属性（例如免税标记）
    const propertiesAttr = this.getAttribute('data-tax-free-properties');
    let lineProperties;
    if (propertiesAttr) {
      try {
        const parsed = JSON.parse(propertiesAttr);
        if (parsed && typeof parsed === 'object') lineProperties = parsed;
      } catch (_) {
        // 非 JSON，按字符串写入一个通用键
        lineProperties = { tax_free: propertiesAttr };
      }
    }

    // 组装主商品项
    const items = [
      {
        id: variantId,
        quantity: mainQty,
        ...(lineProperties ? { properties: lineProperties } : {}),
      },
    ];

    // 检查是否在 product-detail-data-popup 弹窗中
    const isInProductDetailPopup = this.closest('product-detail-data-popup') !== null;

    // 若存在被勾选的推荐商品（例如 products-purchase 模块），且不在产品详情弹窗中，追加到 items
    if (!isInProductDetailPopup) {
      try {
        if (Array.isArray(window.selectedProducts) && window.selectedProducts.length > 0) {
          const extra = window.selectedProducts
            .map((p) => {
              const id = parseInt(p.variantId, 10);
              const qtyParsed = parseInt(p.quantity, 10);
              const qty = Number.isFinite(qtyParsed) && qtyParsed > 0 ? qtyParsed : 1;
              if (!Number.isFinite(id)) return null;
              return {
                id,
                quantity: qty,
                ...(lineProperties ? { properties: lineProperties } : {}),
              };
            })
            .filter(Boolean);
          if (extra.length > 0) items.push(...extra);
        }
      } catch (e) {
        console.error('DynamicAddToCart: 处理 selectedProducts 失败:', e);
      }
    }

    const body = JSON.stringify({
      items,
      sections: sections,
      sections_url: window.location.pathname,
    });

    try {
      const response = await fetch(this.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body,
      });

      const parsedState = await response.json();

      if (parsedState.status === 422) {
        window.litime.showToast('error', parsedState.description);

        document.dispatchEvent(
          new CustomEvent('ajaxProduct:error', {
            detail: {
              errorMessage: parsedState.description,
            },
          }),
        );
      } else {
        if (this.miniCart && typeof this.miniCart.renderContents === 'function') {
          try {
            if (window.location.pathname === '/cart') {
              window.scrollTo(0, 0);
              window.location.reload();
            } else {
              this.miniCart.renderContents(parsedState);
            }
          } catch (error) {
            console.error('renderContents 调用出错:', error);
          }
        }

        // 关闭产品详情弹窗
        this.closeProductDetailModal();

        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            detail: {
              product: parsedState,
            },
          }),
        );
      }
    } catch (error) {
      console.error('添加到购物车失败:', error);
      this.closeProductDetailModal();
    } finally {
      // 隐藏加载状态
      this.hideLoading();
    }
  }
}

customElements.define('add-to-cart', AddToCart);
customElements.define('dynamic-add-to-cart', DynamicAddToCart);
/**
 * 封装的Fetch请求函数
 * @param {string} url - 请求地址
 * @param {Object} options - 配置选项
 * @param {string} options.method - 请求方法：GET, POST, PUT, DELETE等
 * @param {Object} options.headers - 自定义请求头
 * @param {Object|FormData|string} options.data - 请求数据
 * @param {number} options.timeout - 超时时间(毫秒)
 * @param {boolean} options.credentials - 是否发送凭证
 * @param {function} options.onProgress - 上传进度回调(仅适用于POST/PUT)
 * @param {number} options.retries - 请求失败重试次数
 * @param {number} options.retryDelay - 重试间隔(毫秒)
 * @param {string} prefix - 请求前缀默认lt-app 可传值'business-api'
 * @returns {Promise<any>} - 返回处理后的响应数据
 */
const request = async (url, options = {}, prefix = 'lt-app') => {
  const {
    method = 'GET',
    headers = {},
    data = null,
    timeout = 8000,
    credentials = 'same-origin',
    onProgress = null,
    retries = 0,
    retryDelay = 1000,
  } = options;

  let baseUrl = '';
  if (window.base_info.url === 'dev-askstarry.myshopify.com') {
    baseUrl = `https://dev-api.askstarry.com/${prefix}`;
  } else {
    baseUrl = `https://api.askstarry.com/${prefix}`;
  }

  // 创建AbortController用于超时控制
  const controller = new AbortController();
  const { signal } = controller;

  // 设置超时
  const timeoutId = setTimeout(() => {
    controller.abort();
  }, timeout);

  // 处理请求配置
  const config = {
    method,
    headers: {
      'Content-Type': 'application/json',
      shop: window.Shopify.shop,
      ...headers,
    },
    credentials,
    signal,
  };

  const ltToken = window.litime.getLocalStorage('ltToken');
  if (ltToken) {
    config.headers['Authorization'] = `Bearer ${ltToken}`;
  }
  if (Shopify.locale) {
    config.headers['language'] = Shopify.locale;
  }

  // 处理请求体数据
  if (data) {
    if (method !== 'GET') {
      if (data instanceof FormData) {
        // 如果是FormData，移除Content-Type让浏览器自动设置
        delete config.headers['Content-Type'];
        config.body = data;
      } else if (typeof data === 'object') {
        config.body = JSON.stringify(data);
      } else {
        config.body = data;
      }
    } else {
      // 对于GET请求，将data作为URL参数
      const params = new URLSearchParams();
      Object.entries(data).forEach(([key, value]) => {
        params.append(key, value);
      });
      url = `${url}${url.includes('?') ? '&' : '?'}${params.toString()}`;
    }
  }

  // 处理上传进度（如果支持）
  if (onProgress && typeof onProgress === 'function' && method !== 'GET') {
    if (data instanceof FormData && window.XMLHttpRequest) {
      // 使用XHR来支持进度
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open(method, baseUrl + url);

        // 设置请求头
        Object.entries(config.headers).forEach(([key, value]) => {
          xhr.setRequestHeader(key, value);
        });

        xhr.onload = () => {
          clearTimeout(timeoutId);
          if (xhr.status >= 200 && xhr.status < 300) {
            try {
              const data = JSON.parse(xhr.responseText);
              resolve(data);
            } catch (e) {
              resolve(xhr.responseText);
            }
          } else {
            reject(new Error(`${window.i18n.request_failed}，${window.i18n.status_code} ${xhr.status}`));
          }
        };

        xhr.onerror = () => reject(new Error(window.i18n.error_message_network_error));
        xhr.ontimeout = () => reject(new Error(window.i18n.error_message_timeout));

        xhr.upload.onprogress = onProgress;
        xhr.send(data);
      });
    }
  }

  // 实现请求重试
  const fetchWithRetry = async (attempt = 0) => {
    try {
      const response = await fetch(baseUrl + url, config);
      clearTimeout(timeoutId);

      // 处理HTTP错误
      if (!response.ok) {
        if (response.status === 401) {
          window.litime.shopifyLogout();
          throw new Error('401');
        } else {
          console.log('other');
          throw new Error(`${window.i18n.request_failed}，${window.i18n.status_code} ${response.status}`);
        }
      }

      // 尝试解析JSON
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        return await response.json();
      }

      return await response.text();
    } catch (error) {
      // 请求被中止(超时)
      if (error.name === 'AbortError') {
        throw new Error(window.i18n.error_message_timeout);
      }

      // 重试逻辑
      if (attempt < retries) {
        await new Promise((resolve) => setTimeout(resolve, retryDelay));
        return fetchWithRetry(attempt + 1);
      }

      throw error;
    }
  };

  return fetchWithRetry();
};
function shopifyLogout(redirectUrl = null) {
  const url = '/account/logout' + (redirectUrl ? `?redirect=${encodeURIComponent(redirectUrl)}` : '');

  fetch(url, {
    method: 'GET',
    credentials: 'same-origin', // 保持 cookie，保证 logout 生效
  })
    .then((res) => {
      console.log('Logout 请求完成', res);
      if (redirectUrl) {
        // 跳转到指定页面
        window.location.href = redirectUrl;
      } else {
        // 默认刷新当前页
        window.location.reload();
      }
    })
    .catch((err) => {
      console.error('Logout 请求失败', err);
      window.location.reload();
    });
}
function getCookie(name) {
  const match = document.cookie.match(
    new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'),
  );
  return match ? match[1] : null;
}

// 存储信息到localStorage
function setLocalStorage(key, value) {
  if (typeof value === 'object') {
    localStorage.setItem(key, JSON.stringify(value));
  } else {
    localStorage.setItem(key, value);
  }
}

// 获取localStorage信息
function getLocalStorage(key) {
  //is not valid JSON
  const item = localStorage.getItem(key);
  if (typeof item === 'string') {
    try {
      return JSON.parse(item);
    } catch (error) {
      return item;
    }
  }
  return item;
}

// 清除localStorage信息
function clearLocalStorage(key) {
  localStorage.removeItem(key);
}

// 弹窗控制器
class ModalController {
  #modals = new Map();
  constructor() {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const openModals = Array.from(document.querySelectorAll('global-modal[data-is-open]'))
          .filter((modal) => modal.isOpen)
          .sort((a, b) => b.level - a.level);
        openModals[0]?.close();
      }
    });
  }

  register(modalId, { onOpen, onClose } = {}) {
    const modal = document.querySelector(`global-modal[data-modal-id="${modalId}"]`);
    if (!modal) return;

    if (onOpen) modal.addEventListener('modal-opened', (event) => onOpen(event.detail.wrapperEle));
    if (onClose) modal.addEventListener('modal-closed', (event) => onClose(event.detail.wrapperEle));

    this.#modals.set(modalId, modal);
    return modal;
  }

  getModal(modalId) {
    return this.#modals.get(modalId);
  }

  open(modalId) {
    this.#modals.get(modalId)?.open();
  }

  // 关闭指定弹窗
  close(modalId) {
    this.#modals.get(modalId)?.close();
  }
}

// 检查 GSAP 是否已经加载
let gsapLoaded = false;
let gsapDraggableLoaded = false;
let loadingInProgress = false; // 防止多次加载

function gsapLazy(callback) {
  // 如果 GSAP 已经加载，直接执行回调函数
  if (gsapLoaded && gsapDraggableLoaded) {
    callback();
  } else if (!loadingInProgress) {
    loadingInProgress = true; // 标记正在加载

    // 创建一个新的 script 标签用于加载 gsap
    const gsapScript = document.createElement('script');
    gsapScript.src = window.cdnUrl.gsap;
    gsapScript.onload = function () {
      gsapLoaded = true;
      checkAndRun(callback);
    };
    document.body.appendChild(gsapScript);

    // 如果 GSAP Draggable 还没加载，再加载 gsapDraggable
    if (!gsapDraggableLoaded) {
      const draggableScript = document.createElement('script');
      draggableScript.src = window.cdnUrl.gsapDraggable;
      draggableScript.onload = function () {
        gsapDraggableLoaded = true;
        checkAndRun(callback);
      };
      document.body.appendChild(draggableScript);
    }
  } else {
    // 如果正在加载，等待加载完成后再执行
    const interval = setInterval(() => {
      if (gsapLoaded && gsapDraggableLoaded) {
        clearInterval(interval);
        callback();
      }
    }, 100);
  }
}

// 检查 GSAP 和 GSAP Draggable 是否都加载完成
function checkAndRun(callback) {
  if (gsapLoaded && gsapDraggableLoaded) {
    loadingInProgress = false; // 结束加载标记
    callback();
  }
}

// 监听一次后自动取消（埋点常用）
function onVisibleOnce(el, callback, options = {}) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        callback(entry);
        observer.disconnect(); // 只触发一次
      }
    });
  }, options);

  observer.observe(el);
}

function openLitimeApp(router, url) {
  const schemeBase = 'litime://com.litime.litime';

  let scheme = schemeBase;
  if (router) scheme += '/' + encodeURIComponent(router);
  if (url) scheme += '?url=' + encodeURIComponent(url);

  const iosStore = 'https://apps.apple.com/us/app/litime/id6472779872';
  const androidStore = 'https://play.google.com/store/apps/details?id=com.litime.ble';

  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
  const isAndroid = /android/i.test(navigator.userAgent);

  let hasHidden = false;

  // 监听是否进入后台（成功打开 APP）
  const handleVisibility = () => {
    if (document.visibilityState === 'hidden') {
      hasHidden = true; // 成功拉起 App
    }
  };
  document.addEventListener('visibilitychange', handleVisibility);

  // 尝试拉起 APP（添加 try/catch 兼容）
  try {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = scheme;
    document.body.appendChild(iframe);
  } catch (e) {
    // 若浏览器禁止 iframe，直接进入兜底逻辑
    setTimeout(() => {
      document.removeEventListener('visibilitychange', handleVisibility);
      if (isIOS) {
        window.location.href = iosStore;
      } else if (isAndroid) {
        window.location.href = androidStore;
      }
    }, 100);

    return; // 提前结束
  }

  // 2 秒检测是否进入后台
  setTimeout(() => {
    document.removeEventListener('visibilitychange', handleVisibility);

    if (!hasHidden) {
      if (isIOS) {
        window.location.href = iosStore;
      } else if (isAndroid) {
        window.location.href = androidStore;
      }
    }
  }, 2000);
}

/**
 * fireworks - 在指定容器的 canvas 上产生“撒花/纸屑”效果
 *
 * @param {string} containerId 容器元素 id（canvas 会按容器大小铺满）
 * @param {string} canvasId    canvas 元素 id
 * @param {Array<Object>} optionsList 初始触发序列（会按数组依次执行）
 *
 * options 对象字段说明（可选，均有默认值）：
 * {
 *   origin: 'top'|'bottom'|'left'|'right'|'top-left'|'top-right'|'bottom-left'|'bottom-right'   // 生成点（默认 'top'）
 *   direction: 'down'|'up'|'left'|'right'|'down-right'|'down-left'|'up-right'|'up-left'        // 主运动方向（默认 'down'）
 *   count: Number    // 粒子总数（默认 60）
 *   size: Number     // 粒子基准大小 px（默认 9）
 *   spread: Number   // 发散角度（度）（默认 60）
 *   force: Number    // 初速度强度（默认 9）
 *   thrust: Number   // 沿 direction 的持续推力（默认 = Math.max(0.06, force * 0.12)）
 *   thrustDecay: Number // 推力每帧衰减系数（默认 0.95）
 *   globalDown: Number  // 全局向下重力（默认 0.22）
 *   flutterAmp: Number  // 摆动幅度（可选）
 *   flutterFreq: Number // 摆动频率（可选）
 *   drag: Number        // 空气阻力系数（可选）
 * }
 *
 * 返回值：{ destroy() }，可用于停止动画并清理监听器
 */
function fireworks(containerId, canvasId, optionsList = []) {
  const container = document.getElementById(containerId);
  const canvas = document.getElementById(canvasId);
  if (!container || !canvas) {
    throw new Error('container 或 canvas 元素未找到');
  }
  const ctx = canvas.getContext('2d', { alpha: true });

  // --- 常量与工具函数 ---
  const colors = ['#F06058', '#FEDF49', '#f9c74f', '#A7DC58', '#577590', '#43aa8b', '#ffb3c1', '#cbaacb'];
  const shapes = ['rect', 'triangle', 'parallelogram'];
  const directionVectors = {
    down: { x: 0, y: 1 },
    up: { x: 0, y: -1 },
    left: { x: -1, y: 0 },
    right: { x: 1, y: 0 },
    'down-right': { x: 0.7, y: 0.7 },
    'down-left': { x: -0.7, y: 0.7 },
    'up-right': { x: 0.7, y: -0.7 },
    'up-left': { x: -0.7, y: -0.7 },
  };
  const dpr = () => window.devicePixelRatio || 1;
  const rand = (min, max) => Math.random() * (max - min) + min;
  const pick = (arr) => arr[(Math.random() * arr.length) | 0];

  // --- 尺寸与缩放（保持高清） ---
  function resize() {
    const rect = container.getBoundingClientRect();
    const ratio = dpr();
    canvas.width = Math.round(rect.width * ratio);
    canvas.height = Math.round(rect.height * ratio);
    canvas.style.width = rect.width + 'px';
    canvas.style.height = rect.height + 'px';
    // 将绘制坐标缩放到 CSS 像素尺度（绘制时使用）
    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
  }
  const onResize = () => resize();
  window.addEventListener('resize', onResize, { passive: true });
  resize();

  // 防止 canvas 阻挡页面交互（同时保留你后面设置 zIndex 的意图）
  canvas.style.pointerEvents = 'none';

  // --- 粒子定义 ---
  const particles = [];

  class Particle {
    constructor(x, y, vx, vy, size, color, shape, angularVel, opts = {}) {
      this.x = x;
      this.y = y;
      this.vx = vx;
      this.vy = vy;
      this.size = size;
      this.color = color;
      this.shape = shape;
      this.rotation = rand(0, Math.PI * 2);
      this.angularVel = angularVel * (0.6 + Math.random() * 1.4);
      this.life = 0;
      this.ttl = opts.ttl || rand(400, 500) | 0;
      this.opacity = 1;
      this.drag = opts.drag ?? rand(0.985, 0.997);
      this.scaleY = rand(0.6, 1.2);
      this.flutterAmp = opts.flutterAmp ?? rand(0.8, 2.4);
      this.flutterFreq = opts.flutterFreq ?? rand(0.045, 0.18);
      this.thrust = opts.thrust || 0;
      this.thrustDecay = opts.thrustDecay ?? 0.95;
      this.maxVy = opts.maxVy ?? 12 + Math.random() * 6;
      this.dir = opts.dir || { x: 0, y: 1 };
      this.globalDown = opts.globalDown ?? 0.22 * (0.85 + Math.random() * 0.4);
    }

    update() {
      // 阻力影响速度
      this.vx *= this.drag;
      this.vy *= this.drag;

      // 推力沿方向逐帧衰减
      if (this.thrust > 0.001) {
        this.vx += this.dir.x * this.thrust;
        this.vy += this.dir.y * this.thrust;
        this.thrust *= this.thrustDecay;
      }

      // 全局重力
      this.vy += this.globalDown;

      // 少量摆动（基于 life）
      const flutter = Math.sin(this.life * this.flutterFreq) * this.flutterAmp;
      this.x += flutter * 0.3;

      // 更新位置
      this.x += this.vx;
      this.y += this.vy;

      // 限速
      if (this.vy > this.maxVy) this.vy = this.maxVy;
      if (this.vy < -this.maxVy) this.vy = -this.maxVy;

      // 旋转（受速度影响）
      this.rotation += this.angularVel * (0.6 + Math.abs(this.vy) / (this.maxVy * 2));

      this.life++;
      // 75% 后开始淡出（修正：更平滑自然）
      const fadeStart = Math.floor(this.ttl * 0.75);
      if (this.life > fadeStart) {
        this.opacity = Math.max(0, 1 - (this.life - fadeStart) / (this.ttl - fadeStart));
      }
    }

    draw(ctx) {
      ctx.save();
      ctx.globalAlpha = this.opacity;
      ctx.translate(this.x, this.y);
      ctx.rotate(this.rotation);
      ctx.fillStyle = this.color;
      const s = this.size;
      if (this.shape === 'rect') {
        ctx.fillRect(-s / 2, (-s / 2) * this.scaleY, s, s * this.scaleY);
      } else if (this.shape === 'triangle') {
        ctx.beginPath();
        ctx.moveTo(-s / 2, (s / 2) * this.scaleY);
        ctx.lineTo(s / 2, (s / 2) * this.scaleY);
        ctx.lineTo(0, (-s / 2) * this.scaleY);
        ctx.closePath();
        ctx.fill();
      } else {
        // parallelogram
        ctx.beginPath();
        ctx.moveTo(-s / 2, (-s / 2) * this.scaleY);
        ctx.lineTo(s / 2, (-s / 2) * this.scaleY);
        ctx.lineTo(s / 2 - s * 0.3, (s / 2) * this.scaleY);
        ctx.lineTo(-s / 2 - s * 0.3, (s / 2) * this.scaleY);
        ctx.closePath();
        ctx.fill();
      }
      ctx.restore();
    }
  }

  // --- 主动画循环（只启动一次） ---
  let rafId = null;
  function animate() {
    // ---- 清空画布（关键修复） ----
    // 为了避免与 ctx.setTransform 缩放产生冲突，先重置为单位变换（device-pixel 空间），
    // 以 device 像素为单位清空整个 canvas，再恢复绘制时使用的缩放 transform。
    const ratio = dpr();
    // 确保使用默认合成模式
    ctx.globalCompositeOperation = 'source-over';
    // 保存当前变换/状态（虽然我们在 reset 时直接设置 transform，但保存以防未来扩展）
    ctx.save();
    ctx.setTransform(1, 0, 0, 1, 0, 0); // 重置 transform 到 device 像素坐标
    ctx.clearRect(0, 0, canvas.width, canvas.height); // 以 device 像素清空整个画布
    ctx.restore();
    // 恢复用于绘制的缩放（与 resize 中设置一致）
    ctx.setTransform(ratio, 0, 0, ratio, 0, 0);

    const w = canvas.width / ratio;
    const h = canvas.height / ratio;

    for (let i = particles.length - 1; i >= 0; i--) {
      const p = particles[i];
      p.update();
      p.draw(ctx);
      // 移除超时或超出视野的粒子
      if (p.life > p.ttl || p.opacity <= 0.01 || p.x < -30 || p.x > w + 30 || p.y < -30 || p.y > h + 30) {
        particles.splice(i, 1);
      }
    }

    rafId = requestAnimationFrame(animate);
  }
  if (!rafId) animate();

  // --- 计算生成点 ---
  function getSpawnPosition(origin) {
    const w = canvas.width / dpr();
    const h = canvas.height / dpr();
    switch (origin) {
      case 'top':
        return { x: w / 2, y: -10 }; // 从顶部中间
      case 'bottom':
        return { x: w / 2, y: h + 10 }; // 从底部中间
      case 'left':
        return { x: -10, y: h / 2 }; // 从左边中间
      case 'right':
        return { x: w + 10, y: h / 2 }; // 从右边中间
      case 'top-left':
        return { x: -10, y: -10 }; // 左上角
      case 'top-right':
        return { x: w + 10, y: -10 }; // 右上角
      case 'bottom-left':
        return { x: -10, y: h + 10 }; // 左下角
      case 'bottom-right':
        return { x: w + 10, y: h + 10 }; // 右下角
      default:
        return { x: rand(0, w), y: -10 }; // 默认为顶部
    }
  }

  // --- 单次强力喷发（confettiBurst），保留三段喷发逻辑与参数调整 ---
  function confettiBurst(opts = {}) {
    const origin = opts.origin || 'top';
    const direction = opts.direction || 'down';
    const count = opts.count || 60;
    const size = opts.size || 9;
    const spread = opts.spread || 60;
    const force = opts.force || 9;

    const thrustDefault = opts.thrust !== undefined ? opts.thrust : Math.max(0.06, force * 0.12);
    const thrustDecay = opts.thrustDecay !== undefined ? opts.thrustDecay : 0.95;
    const globalDown = opts.globalDown !== undefined ? opts.globalDown : 0.22;
    const flutterAmpOption = opts.flutterAmp;
    const flutterFreqOption = opts.flutterFreq;

    const dirVec = directionVectors[direction] || directionVectors.down;
    const spawn = getSpawnPosition(origin);

    // 三段喷发分配（与原实现一致）
    const bursts = [
      { c: Math.floor(count * 0.4), s: spread, f: force, thrustScale: 1.0 },
      { c: Math.floor(count * 0.3), s: spread * 0.6, f: force * 0.55, thrustScale: 0.6 },
      { c: Math.floor(count * 0.5), s: spread * 1.6, f: force * 1.15, thrustScale: 1.3 },
    ];

    // 逐段生成粒子（原代码段内使用 setTimeout(...,0)，等同于立即生成）
    bursts.forEach((b) => {
      for (let j = 0; j < b.c; j++) {
        const angle = Math.atan2(dirVec.y, dirVec.x) + (rand(-b.s, b.s) * Math.PI) / 180;
        const speed = rand(b.f * 0.6, b.f * 1.15);
        const vx = Math.cos(angle) * speed + rand(-0.6, 0.6);
        const vy = Math.sin(angle) * speed + rand(-0.6, 0.6);

        const p = new Particle(
          spawn.x + rand(-8, 8),
          spawn.y + rand(-8, 8),
          vx,
          vy,
          rand(size * 0.6, size * 1.2),
          pick(colors),
          pick(shapes),
          rand(-0.18, 0.18),
          {
            ttl: rand(400, 500) | 0,
            drag: opts.drag ?? rand(0.985, 0.996),
            flutterAmp: flutterAmpOption,
            flutterFreq: flutterFreqOption,
            thrust: thrustDefault * (b.thrustScale || 1),
            thrustDecay,
            maxVy: 12 + Math.random() * 6,
            dir: dirVec,
            globalDown,
          },
        );

        particles.push(p);
      }
    });
  }

  // --- 对外 API：批量触发 optionsList 中的喷发（保持原行为） ---
  optionsList.forEach((o) => confettiBurst(o));
  canvas.style.zIndex = -1;

  // 返回控制句柄（可销毁）
  function destroy() {
    window.removeEventListener('resize', onResize);
    if (rafId) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
    particles.length = 0;
    // 清空画布（device 像素单位）
    ctx.save();
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
  }

  // 仍保持 window.confettiBurst 以兼容原代码使用习惯
  window.confettiBurst = confettiBurst;

  return { destroy };
}
